import React, { useCallback, useState } from 'react'

import { Button } from '@driftt/tide-core'
import { Modal, ModalBody, ModalFooter, ModalTitle } from '@driftt/tide-modal'

import { deleteSendingDomain } from '../api'

const DeleteDomainModal = ({ sendingDomain, onClose, onDelete }) => {
  const { id, domain } = sendingDomain
  const [error, setError] = useState(null)
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDelete = useCallback(() => {
    setIsDeleting(true)
    deleteSendingDomain(id)
      .then(() => onDelete(id))
      .catch(() => setError('An error occurred'))
      .finally(() => setIsDeleting(false))
  }, [id, onDelete])

  return (
    <Modal open="on" size="small" status="warning" onClose={onClose}>
      <ModalTitle>Confirm domain deletion</ModalTitle>
      <ModalBody>
        Are you sure you want to delete {domain}?
        {error && <p className="delete-domain-modal--error">{error}</p>}
      </ModalBody>
      <ModalFooter>
        <Button
          type="secondary"
          className="delete-domain-modal--confirm-button"
          onClick={handleDelete}
          loading={isDeleting}
        >
          Confirm
        </Button>
        <Button type="tertiary" onClick={onClose}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default DeleteDomainModal
